import { DataTable } from "primereact/datatable";
import { IClientDetail } from "./ClientTnfr";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { ILogin } from "../../models/Login";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";

interface model {
    data: IClientDetail,
    loading?: boolean,
}

interface IEscalationList {
    id?: number,
    pO_ID?: number,
    vendor_Type?: number,
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    added_By?: string,
    company?: string,
    branch?: string,
    escalation_Subject?: string,
    escalation_Comment?: string,
    escalation_Status?: string,
    added_On?: Date,
    updated_By?: string,
    updated_On?: Date,
}

export const Table = ({ data, loading }: model) => {
    const [openEscalationModal, setOpenEscalationModal] = useState({ singleData: {}, open: false } as { singleData: IEscalationList, open: boolean });
    const [escalationTableData, setEscalationTableData] = useState({ tableData: [], loading: false } as { tableData: IEscalationList[], loading: boolean });

    const add_Date = (rowData: IClientDetail) => {
        let date;
        if (rowData.last_Transfer_Date) date = format(new Date(rowData.last_Transfer_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const reqPostedDate = (rowData: IClientDetail) => {
        let date;
        if (rowData.recentReqPostedDate) date = format(new Date(rowData.recentReqPostedDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadEscalationTableData = async (companyID: number) => {
        setEscalationTableData({ tableData: [], loading: true });
        const response = await Fetch("vwPODetails/getVendorEscalation", "GET", null, `poID=0&companyID=${companyID}`, null);
        if (response) {
            const data: IEscalationList[] = await response.json();
            setEscalationTableData({ tableData: data, loading: false });
        } else setEscalationTableData({ tableData: [], loading: false });
    }

    useEffect(() => {
        loadEscalationTableData(data.vendor_Company_ID || 0);
    }, [data.vendor_Company_ID]);

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" showGridlines stripedRows responsiveLayout="scroll"
                value={[data]} loading={loading}
            >
                <Column field="contact_Person_Name" header="Contact Person" />
                <Column field="contact_Person_EmailID" header="Email" />
                {(_roles.includes(1) || _roles.includes(26)) && <Column field="cell_No" header="Cell No" />}
                {(_roles.includes(1) || _roles.includes(26)) && <Column field="phone_No" header="Phone No" />}
                <Column field="vendor_Company_Name" header="Company Name" />
                <Column field="major_Technology" header="Major Skills" />
                <Column field="city_Name" header="City" />
                <Column field="state_Name" header="State" />
                <Column field="last_Transfer_Date" header="Last Transfer" body={add_Date} />
                <Column field="noofReq" header="Req#" sortable />
                <Column field="noOfServe" header="Serv#" sortable />
                <Column field="noOfResume" header="Sub#" sortable />
                <Column field="noEndClient" header="ECS#" sortable />
                <Column field="noOfECI" header="ECI#" sortable />
                <Column field="noOfPO" header="PO#" sortable />
                <Column field="recentReqPostedDate" header="Recent Posted" body={reqPostedDate} />
                <Column header="Escalation" body={(rowData: IClientDetail) => <Button className="p-button-rounded p-button-info p-button-text" type="button" tooltip="View Escalation" icon="pi pi-eye" onClick={() => {
                    setOpenEscalationModal({ singleData: {}, open: true });
                }}></Button>} />
            </DataTable>
            <Dialog visible={openEscalationModal.open} style={{ width: '80vw' }} header="Vendor Escalation" className="p-fluid" onHide={() => {
                setOpenEscalationModal({ singleData: {}, open: false });
            }}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" value={escalationTableData.tableData} loading={escalationTableData.loading} showGridlines stripedRows responsiveLayout="scroll"
                >
                    <Column field="vendor_Type" header="Vendor Type" body={(rowData: IEscalationList) => <p>{rowData.vendor_Type === 1 ? "Prime Vendor" : "Sub Vendor"}</p>} />
                    <Column field="vendor_Company_Name" header="Vendor Company" />
                    <Column field="added_By" header="Added By" />
                    <Column field="company" header="Company" />
                    <Column field="branch" header="Branch" />
                    <Column field="escalation_Subject" header="Escalation Subject" />
                    <Column field="escalation_Comment" header="Escalation Comment" />
                    <Column field="escalation_Status" header="Status" />
                </DataTable>
            </Dialog>
        </>
    );
}